import React, { FC, ReactNode } from 'react';
import { Flex, Select } from '@duxton-web/ui';

import { ConstraintValueItemType } from '@/common/const';
import FacetComponent from '@/common/ConstraintsEditor/Constraint/FacetComponent';
import { getValueItemTypeOptions } from '@/common/valueItemType';
import { Constraint } from '@/lib/App';

interface GroupSelector {
  mode?: 'multiple' | 'tags';
  constraint: Constraint;
  disableInlineGroup?: boolean;
  disabled?: boolean;
  onChange: (constraint: Constraint) => void;
}

const GroupSelector: FC<GroupSelector> = ({
  mode,
  constraint,
  disableInlineGroup,
  disabled = false,
  onChange,
}) => {
  function formatValueBasedOnValueItemType(values: string | string[]): string {
    if (!values) return '';

    if (constraint?.valueItemType === ConstraintValueItemType.INLINE.value) {
      if (typeof values === 'string') return `[${values}]`;

      return `[${values.join(',')}]`;
    }

    if (typeof values === 'string') return values;

    return values.join(',');
  }

  function renderValueTypeSelect(constraint: Constraint): ReactNode {
    const valueItemTypeOptions = getValueItemTypeOptions(constraint).filter(
      (option) => {
        if (disableInlineGroup) return option.value !== 'group.inline';
        return true;
      },
    );

    if (valueItemTypeOptions.length == 1) return false;

    return (
      <Select
        style={{ width: 150, height: 40 }}
        placeholder="Select"
        disabled={disabled}
        onChange={(e) => {
          onChange({
            ...constraint,
            valueItemType: e,
            value: '',
          });
        }}
        options={valueItemTypeOptions}
        value={constraint.valueItemType}
      />
    );
  }

  return (
    <Flex
      align="center"
      gap={8}
      wrap="wrap"
      style={{
        overflow: 'hidden',
      }}
    >
      {renderValueTypeSelect(constraint)}
      <div>
        <FacetComponent
          mode={mode}
          constraint={constraint}
          handleChange={(e) => {
            onChange({
              ...constraint,
              value: formatValueBasedOnValueItemType(e.value),
            });
          }}
          facetName={constraint.target}
          disabled={disabled}
        />
      </div>
    </Flex>
  );
};

export default GroupSelector;
